import { useCallback } from "react";
import { useSelector } from "react-redux";
import { currenciesNameSelector } from "../store/slice/settings";

const useCurrencyName = () => {
  const currenciesName = useSelector(currenciesNameSelector);
  return useCallback(
    code => {
      if (code in currenciesName) return currenciesName[code];
      return code;
    },
    [currenciesName]
  );
};

export default useCurrencyName;
